<template>
  <div>
    <div class="flex just-between">
      <div class="flex align-center" style="height: 40px">
        <div
          class="iconfont"
          :class="listData.icon"
          style="
            width: 26px;
            height: 26px;
            margin-right: 10px;
            font-size: 26px;
            color: #76040b;
          "
        ></div>
        <div style="font-size: 20px; color: #76040b" class="font-bold">
          {{ listData.name }}
        </div>
      </div>
      <div class="cursor-pointer more" @click="gotoMore">更多>></div>
    </div>
    <div style="border-top: 1px solid #d5d5d5; padding: 10px 0;min-height:285px;">
      <template v-if="itemList.length > 0">
        <div
          class="flex align-center"
          style="margin-bottom: 20px"
          v-for="(item, index) in itemList"
          :key="index"
        >
          <div class="date-class">
            <div
              style="
                width: 100%;
                border-right: 1px solid #76040b;
                color: #fff;
                background: #76040b;
              "
            >
              {{ item.publishTime }}
            </div>
          </div>
          <div class="elipsis-class cursor-pointer" style="width: 296px" @click="gotoDetail(item)">{{ item.title }}</div>
          <!-- <router-link
            class="elipsis-class cursor-pointer"
            style="width: 296px"
            :to="{
              name: 'noticeDetaile',
              params: {
                id: listData.id,
                noticeId: item.id,
              },
            }"
            >{{ item.title }}</router-link
          > -->
        </div>
      </template>
      <template v-else>
        <div class="text-center">
          暂无数据
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      itemList: [],
    };
  },
  methods: {
    gotoDetail (item) {
      localStorage.setItem('sort', this.listData.id)
      this.$router.push({
        name: 'noticeDetaile',
        params: {
          id: this.listData.id,
          noticeId: item.id,
        }
      })
    },
    gotoMore () {
      localStorage.setItem('sort', this.listData.id)
      this.$router.push({
        path: '/list/' + this.listData.id
      })
    },
    getItemInfo() {
      const param = {
        categoryId: this.listData.id,
        pageSize: 6,
      };
      this.$api.index.getMsgList(param).then((res) => {
        if (res.code === 200) {
          if (res.data.content.length > 0) {
            res.data.content.forEach((item) => {
              item.publishTime = item.publishTime.split("T")[0];
            });
          }
          this.itemList = res.data.content;
        }
      });
    },
  },
  mounted() {
    this.getItemInfo();
  },
};
</script>

<style scoped lang="less">
a.elipsis-class.cursor-pointer {
  color: #232324;
}

a.elipsis-class.cursor-pointer:hover {
  color: rgb(202, 28, 29);
}
.more {
  font-size: 14px;
  color: #444;
  height: 40px;
  line-height: 40px;
}
.elipsis-class {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.date-class {
  width: 86px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  color: #fff;
  margin-right: 10px;
  text-align: center;
}
</style>
